module.exports = __webpack_public_path__ + "static/media/filter_clear.b89ad730.png";